import axios from "axios";

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL || "https://api.my-cron.com/api",
	withCredentials: true,
	headers: {
		"Content-Type": "application/json",
	},
});

// Add request interceptor
api.interceptors.request.use(
	(config) => {
		// Add any auth tokens if needed
		return config;
	},
	(error) => {
		console.error("API Request Error:", error);
		return Promise.reject(error);
	}
);

// Add response interceptor
api.interceptors.response.use(
	(response) => response,
	(error) => {
		console.error("API Response Error:", {
			status: error.response?.status,
			message: error.message,
			data: error.response?.data,
		});
		return Promise.reject(error);
	}
);
